import { useEffect, useState } from 'react';
import Image from 'next/image';

import Facebook from '@/icons/light/facebook.svg';
import Linkedin from '@/icons/light/linkedin.svg';
import Twitter from '@/icons/light/twitter.svg';
import { Container } from '@/atoms';
import { Prose } from '@/molecules';

import type { FunctionComponent } from 'react';
import type { TypeBlogArticleProps } from './types';

export const BlogArticle: FunctionComponent<TypeBlogArticleProps> = ({
  className = '',
  title,
  date,
  image,
  socialMediaTitle,
  articleText,
}: TypeBlogArticleProps) => {
  const [url, setUrl] = useState('');

  useEffect(() => {
    setUrl(document.URL);
  }, []);

  return (
    <div className={className}>
      <Container
        wrapper
        wrapperSize="max-w-[790px]"
        padding="px-4 py-4 md:py-12"
      >
        <h1 className="text-headline text-headline-h2">{title}</h1>

        <div className="mt-6 flex gap-4">
          <span className="text-body text-body-m">{date}</span>
        </div>
      </Container>

      <Container
        wrapper
        wrapperSize="max-w-[1440px]"
        classNameWrapper="h-[180px] md:h-[400px]"
        padding=""
      >
        <Image
          src={image}
          alt={socialMediaTitle}
          className="object-cover"
          fill
        />
      </Container>

      <Container
        wrapper
        wrapperSize="max-w-[790px]"
        padding="px-4 py-4 md:py-12"
      >
        <Prose html={articleText} />

        <div className="mt-10 flex flex-col gap-4">
          <span className="text-body text-body-l font-bold">
            {socialMediaTitle}
          </span>

          <div className="flex flex-row gap-4">
            <a
              href={`https://www.linkedin.com/sharing/share-offsite/?url=${url}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-text-neutrals-900"
            >
              <Linkedin width={24} height={24} />
            </a>
            <a
              href={`https://twitter.com/intent/tweet?url=${url}&text=${title}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-text-neutrals-900"
            >
              <Twitter width={24} height={24} />
            </a>
            <a
              href={`https://www.facebook.com/sharer.php?u=${url}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-text-neutrals-900"
            >
              <Facebook width={24} height={24} />
            </a>
          </div>
        </div>
      </Container>
    </div>
  );
};

BlogArticle.displayName = 'BlogArticle';
